import styled from '@emotion/styled';

export const ValuesDifference = styled('div')`
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 1.3rem 2rem;
`;

export const SellSide = styled('div')``;

export const RemainSide = styled('div')`
  text-align: right;
`;

export const Amount = styled('div')`
  font-size: 2.2rem;
  line-height: 1.18;
`;
